import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = state => state[STATE_KEY_NAME];

const organizationSelector = createSelector(stateSelector, state => state.organization);
const enforceAuth2Selector = createSelector(organizationSelector, currOrg => {
  if (currOrg) return currOrg.enforce_auth2;

  return false;
});
const isOrganizationSettingsLoadingSelector = createSelector(
  stateSelector,
  state => state.isFetchingOrganizationSettings,
);
const organizationSettingsSelector = createSelector(stateSelector, state => state.organizationSettings || {});
const appLoadedSelector = createSelector(stateSelector, state => state.appLoaded);
const searchLoaderSelector = createSelector(stateSelector, state => state.loaderProgress);
const printSelector = createSelector(stateSelector, state => state.print);
const printModeSelector = createSelector(stateSelector, state => state.print.mode);
const isDetailedLogSelector = createSelector(organizationSettingsSelector, state => state.detailed_log);
const pendingMembersSelectors = createSelector(stateSelector, state => state.pendingMembers);

export const AppSelectors = {
  pendingMembersSelectors,
  organizationSelector,
  enforceAuth2Selector,

  searchLoaderSelector,
  appLoadedSelector,
  printSelector,
  printModeSelector,
  isDetailedLogSelector,
  isOrganizationSettingsLoadingSelector,
};
